<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <dialog
    :id="id"
    class="custom-dialog"
    :open="visible"
    @close="$emit('update:visible', false)"
  >
    <div class="dialog-header">
      <slot name="header">{{ header }}</slot>
      <button
        class="close-button"
        aria-label="Close dialog"
        @click="$emit('update:visible', false)"
      >
        ×
      </button>
    </div>
    <div class="dialog-content" v-if="$slots.default">
      <slot></slot> <!-- Use default slot instead of named content slot -->
    </div>
    <div class="dialog-footer">
      <slot name="footer">
        <!-- Uncomment if needed -->
        <!-- <button
          class="dialog-button cancel-button"
          @click="$emit('update:visible', false)"
        >
          Cancel
        </button>
        <button
          class="dialog-button confirm-button"
          @click="$emit('confirm')"
        >
          Confirm
        </button> -->
      </slot>
    </div>
  </dialog>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: "Dialog Title",
    },
    position: { // Added for PrimeVue compatibility
      type: String,
      default: "center",
    },
    modal: { // Added for PrimeVue compatibility
      type: Boolean,
      default: true,
    },
    breakpoints: { // Added for PrimeVue compatibility
      type: Object,
      default: () => ({}),
    },
    style: { // Added for PrimeVue compatibility
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:visible", "confirm"],
  watch: {
    visible(newVal) {
      const dialog = this.$el;
      if (newVal) {
        dialog.showModal(); // Open the dialog
      } else {
        dialog.close(); // Close the dialog
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-dialog {
  border: 1px solid #c0c0bc;
  border-radius: 6px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 90%;
  background-color: #ffffff;
  font-family: "Voyado Text", sans-serif;
  color: #21211f;
  padding: 0;
}

.custom-dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.5); // Added for modal backdrop
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  font-size: 18px;
  font-weight: 500;
  border-bottom: 1px solid #e9ecef;
  background: #f0f0ef;
  color: #2d6e6d;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
}

.close-button:hover {
  color: #21211f;
}

.dialog-content {
  padding: 1rem;
  font-size: 16px;
  line-height: 1.5;
}

.dialog-content:empty {
  padding: 0;
  min-height: 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem;
  border-top: 1px solid #fff;
  background-color: #fff;
}
</style>